import { AUDIT_DEFAULT_TIMEZONE, canonicalAuditTimeZone } from '@numeo/types-core'

/** The viewer's own time zone: the audit cuts days at the viewer's midnight, whoever is looking (ADR-022 Gluon audit). */
export const VIEWER_TIME_ZONE: string = (() => {
    return canonicalAuditTimeZone(Intl.DateTimeFormat().resolvedOptions().timeZone) ?? AUDIT_DEFAULT_TIMEZONE
})()

/** The zone's name for labels, e.g. "Central Time" (or "CT" with `short`); the IANA name if the browser has none. */
export function timeZoneName(timeZone: string = VIEWER_TIME_ZONE, short = false): string {
    try {
        const part = new Intl.DateTimeFormat('en-US', { timeZone, timeZoneName: short ? 'shortGeneric' : 'longGeneric' })
            .formatToParts(new Date())
            .find((p) => p.type === 'timeZoneName')
        return part?.value ?? timeZone
    } catch {
        return timeZone
    }
}
